/* tslint:disable */
/* eslint-disable */
/**
 * AllOfUs Workbench API
 * The API for the AllOfUs workbench.  Throughout, we use integer/int64 in preference to string/date-time because Swagger\'s date formatting is inconsistent between server and client. Time values are stored as milliseconds since the UNIX epoch.  Note: all requests tagged as \"cron\" must have the header X-Appengine-Cron: true, which app engine itself only sets when invoking as a cronjob. See https://cloud.google.com/appengine/docs/standard/java/config/cron#securing_urls_for_cron and o.p.w.interceptors.CronInterceptor which implements the header check. 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ErrorResponse,
  GetVwbWorkspaceResources200Response,
  PreprodWorkspace,
  VwbAodRequest,
  VwbPodDescription,
  VwbWorkspaceAdminView,
  VwbWorkspaceAuditLog,
  VwbWorkspaceListResponse,
} from '../models';
import {
    ErrorResponseFromJSON,
    ErrorResponseToJSON,
    GetVwbWorkspaceResources200ResponseFromJSON,
    GetVwbWorkspaceResources200ResponseToJSON,
    PreprodWorkspaceFromJSON,
    PreprodWorkspaceToJSON,
    VwbAodRequestFromJSON,
    VwbAodRequestToJSON,
    VwbPodDescriptionFromJSON,
    VwbPodDescriptionToJSON,
    VwbWorkspaceAdminViewFromJSON,
    VwbWorkspaceAdminViewToJSON,
    VwbWorkspaceAuditLogFromJSON,
    VwbWorkspaceAuditLogToJSON,
    VwbWorkspaceListResponseFromJSON,
    VwbWorkspaceListResponseToJSON,
} from '../models';

export interface VwbWorkspaceAdminApiDeleteVwbWorkspaceResourceRequest {
    workspaceId: string;
    resourceId: string;
    resourceType: string;
}

export interface VwbWorkspaceAdminApiEnableAccessOnDemandByUserFacingIdRequest {
    workspaceUserFacingId: string;
    vwbAodRequest: VwbAodRequest;
}

export interface VwbWorkspaceAdminApiGetPodsRequest {
    username: string;
}

export interface VwbWorkspaceAdminApiGetPreprodWorkspaceRequest {
    workspaceNamespace: string;
}

export interface VwbWorkspaceAdminApiGetVwbWorkspaceActivityLogsRequest {
    workspaceId: string;
    limit?: number;
    offset?: number;
}

export interface VwbWorkspaceAdminApiGetVwbWorkspaceAdminViewRequest {
    workspaceUserFacingId: string;
}

export interface VwbWorkspaceAdminApiGetVwbWorkspaceAuditLogsRequest {
    workspaceId: string;
    limit?: number;
    offset?: number;
}

export interface VwbWorkspaceAdminApiGetVwbWorkspaceResourcesRequest {
    workspaceId: string;
}

export interface VwbWorkspaceAdminApiGetVwbWorkspacesBySearchParamRequest {
    searchParamType: string;
    searchParam: string;
}

/**
 * 
 */
export class VwbWorkspaceAdminApi extends runtime.BaseAPI {

    /**
     * Deletes a workspace resource using service account credentials. Requires RESEARCHER_DATA_VIEW authority.
     */
    async deleteVwbWorkspaceResourceRaw(requestParameters: VwbWorkspaceAdminApiDeleteVwbWorkspaceResourceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.workspaceId === null || requestParameters.workspaceId === undefined) {
            throw new runtime.RequiredError('workspaceId','Required parameter requestParameters.workspaceId was null or undefined when calling deleteVwbWorkspaceResource.');
        }

        if (requestParameters.resourceId === null || requestParameters.resourceId === undefined) {
            throw new runtime.RequiredError('resourceId','Required parameter requestParameters.resourceId was null or undefined when calling deleteVwbWorkspaceResource.');
        }

        if (requestParameters.resourceType === null || requestParameters.resourceType === undefined) {
            throw new runtime.RequiredError('resourceType','Required parameter requestParameters.resourceType was null or undefined when calling deleteVwbWorkspaceResource.');
        }

        const queryParameters: any = {};

        if (requestParameters.resourceType !== undefined) {
            queryParameters['resourceType'] = requestParameters.resourceType;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("aou_oauth", []);
        }

        const response = await this.request({
            path: `/v2/admin/vwb/workspaces/{workspaceId}/resources/{resourceId}`.replace(`{${"workspaceId"}}`, encodeURIComponent(String(requestParameters.workspaceId))).replace(`{${"resourceId"}}`, encodeURIComponent(String(requestParameters.resourceId))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Deletes a workspace resource using service account credentials. Requires RESEARCHER_DATA_VIEW authority.
     */
    async deleteVwbWorkspaceResource(workspaceId: string, resourceId: string, resourceType: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteVwbWorkspaceResourceRaw({ workspaceId: workspaceId, resourceId: resourceId, resourceType: resourceType }, initOverrides);
    }

    /**
     * Given a workspace user facing id, requests access on demand on the workspace. Requires RESEARCHER_DATA_VIEW authority.
     */
    async enableAccessOnDemandByUserFacingIdRaw(requestParameters: VwbWorkspaceAdminApiEnableAccessOnDemandByUserFacingIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.workspaceUserFacingId === null || requestParameters.workspaceUserFacingId === undefined) {
            throw new runtime.RequiredError('workspaceUserFacingId','Required parameter requestParameters.workspaceUserFacingId was null or undefined when calling enableAccessOnDemandByUserFacingId.');
        }

        if (requestParameters.vwbAodRequest === null || requestParameters.vwbAodRequest === undefined) {
            throw new runtime.RequiredError('vwbAodRequest','Required parameter requestParameters.vwbAodRequest was null or undefined when calling enableAccessOnDemandByUserFacingId.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("aou_oauth", []);
        }

        const response = await this.request({
            path: `/v2/admin/vwb/workspaces/{workspaceUserFacingId}/aod`.replace(`{${"workspaceUserFacingId"}}`, encodeURIComponent(String(requestParameters.workspaceUserFacingId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: VwbAodRequestToJSON(requestParameters.vwbAodRequest),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Given a workspace user facing id, requests access on demand on the workspace. Requires RESEARCHER_DATA_VIEW authority.
     */
    async enableAccessOnDemandByUserFacingId(workspaceUserFacingId: string, vwbAodRequest: VwbAodRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.enableAccessOnDemandByUserFacingIdRaw({ workspaceUserFacingId: workspaceUserFacingId, vwbAodRequest: vwbAodRequest }, initOverrides);
    }

    /**
     * Returns all VWB pods available for the provided username. Requires RESEARCHER_DATA_VIEW authority.
     */
    async getPodsRaw(requestParameters: VwbWorkspaceAdminApiGetPodsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<VwbPodDescription>>> {
        if (requestParameters.username === null || requestParameters.username === undefined) {
            throw new runtime.RequiredError('username','Required parameter requestParameters.username was null or undefined when calling getPods.');
        }

        const queryParameters: any = {};

        if (requestParameters.username !== undefined) {
            queryParameters['username'] = requestParameters.username;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("aou_oauth", []);
        }

        const response = await this.request({
            path: `/v2/admin/vwb/pods`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(VwbPodDescriptionFromJSON));
    }

    /**
     * Returns all VWB pods available for the provided username. Requires RESEARCHER_DATA_VIEW authority.
     */
    async getPods(username: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<VwbPodDescription>> {
        const response = await this.getPodsRaw({ username: username }, initOverrides);
        return await response.value();
    }

    /**
     * Given a preprod workspace namespace, returns workspace details. Requires RESEARCHER_DATA_VIEW authority.
     */
    async getPreprodWorkspaceRaw(requestParameters: VwbWorkspaceAdminApiGetPreprodWorkspaceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<PreprodWorkspace>>> {
        if (requestParameters.workspaceNamespace === null || requestParameters.workspaceNamespace === undefined) {
            throw new runtime.RequiredError('workspaceNamespace','Required parameter requestParameters.workspaceNamespace was null or undefined when calling getPreprodWorkspace.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("aou_oauth", []);
        }

        const response = await this.request({
            path: `/v2/admin/vwb/workspaces/preprod/{workspaceNamespace}`.replace(`{${"workspaceNamespace"}}`, encodeURIComponent(String(requestParameters.workspaceNamespace))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(PreprodWorkspaceFromJSON));
    }

    /**
     * Given a preprod workspace namespace, returns workspace details. Requires RESEARCHER_DATA_VIEW authority.
     */
    async getPreprodWorkspace(workspaceNamespace: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<PreprodWorkspace>> {
        const response = await this.getPreprodWorkspaceRaw({ workspaceNamespace: workspaceNamespace }, initOverrides);
        return await response.value();
    }

    /**
     * Returns VWB workspace activity logs for the given workspace. Supports pagination via limit/offset. Requires RESEARCHER_DATA_VIEW authority.
     */
    async getVwbWorkspaceActivityLogsRaw(requestParameters: VwbWorkspaceAdminApiGetVwbWorkspaceActivityLogsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<VwbWorkspaceAuditLog>>> {
        if (requestParameters.workspaceId === null || requestParameters.workspaceId === undefined) {
            throw new runtime.RequiredError('workspaceId','Required parameter requestParameters.workspaceId was null or undefined when calling getVwbWorkspaceActivityLogs.');
        }

        const queryParameters: any = {};

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("aou_oauth", []);
        }

        const response = await this.request({
            path: `/v2/admin/vwb/workspaces/{workspaceId}/activity-logs`.replace(`{${"workspaceId"}}`, encodeURIComponent(String(requestParameters.workspaceId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(VwbWorkspaceAuditLogFromJSON));
    }

    /**
     * Returns VWB workspace activity logs for the given workspace. Supports pagination via limit/offset. Requires RESEARCHER_DATA_VIEW authority.
     */
    async getVwbWorkspaceActivityLogs(workspaceId: string, limit?: number, offset?: number, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<VwbWorkspaceAuditLog>> {
        const response = await this.getVwbWorkspaceActivityLogsRaw({ workspaceId: workspaceId, limit: limit, offset: offset }, initOverrides);
        return await response.value();
    }

    /**
     * Given a workspace user facing id, returns workspace details. Requires RESEARCHER_DATA_VIEW authority.
     */
    async getVwbWorkspaceAdminViewRaw(requestParameters: VwbWorkspaceAdminApiGetVwbWorkspaceAdminViewRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<VwbWorkspaceAdminView>> {
        if (requestParameters.workspaceUserFacingId === null || requestParameters.workspaceUserFacingId === undefined) {
            throw new runtime.RequiredError('workspaceUserFacingId','Required parameter requestParameters.workspaceUserFacingId was null or undefined when calling getVwbWorkspaceAdminView.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("aou_oauth", []);
        }

        const response = await this.request({
            path: `/v2/admin/vwb/workspaces/{workspaceUserFacingId}`.replace(`{${"workspaceUserFacingId"}}`, encodeURIComponent(String(requestParameters.workspaceUserFacingId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => VwbWorkspaceAdminViewFromJSON(jsonValue));
    }

    /**
     * Given a workspace user facing id, returns workspace details. Requires RESEARCHER_DATA_VIEW authority.
     */
    async getVwbWorkspaceAdminView(workspaceUserFacingId: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<VwbWorkspaceAdminView> {
        const response = await this.getVwbWorkspaceAdminViewRaw({ workspaceUserFacingId: workspaceUserFacingId }, initOverrides);
        return await response.value();
    }

    /**
     * Returns VWB workspace audit logs for the given workspace. Supports pagination via limit/offset. Requires RESEARCHER_DATA_VIEW authority.
     */
    async getVwbWorkspaceAuditLogsRaw(requestParameters: VwbWorkspaceAdminApiGetVwbWorkspaceAuditLogsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<VwbWorkspaceAuditLog>>> {
        if (requestParameters.workspaceId === null || requestParameters.workspaceId === undefined) {
            throw new runtime.RequiredError('workspaceId','Required parameter requestParameters.workspaceId was null or undefined when calling getVwbWorkspaceAuditLogs.');
        }

        const queryParameters: any = {};

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("aou_oauth", []);
        }

        const response = await this.request({
            path: `/v2/admin/vwb/workspaces/{workspaceId}/audit`.replace(`{${"workspaceId"}}`, encodeURIComponent(String(requestParameters.workspaceId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(VwbWorkspaceAuditLogFromJSON));
    }

    /**
     * Returns VWB workspace audit logs for the given workspace. Supports pagination via limit/offset. Requires RESEARCHER_DATA_VIEW authority.
     */
    async getVwbWorkspaceAuditLogs(workspaceId: string, limit?: number, offset?: number, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<VwbWorkspaceAuditLog>> {
        const response = await this.getVwbWorkspaceAuditLogsRaw({ workspaceId: workspaceId, limit: limit, offset: offset }, initOverrides);
        return await response.value();
    }

    /**
     * Returns workspace resources using service account credentials. Requires RESEARCHER_DATA_VIEW authority.
     */
    async getVwbWorkspaceResourcesRaw(requestParameters: VwbWorkspaceAdminApiGetVwbWorkspaceResourcesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetVwbWorkspaceResources200Response>> {
        if (requestParameters.workspaceId === null || requestParameters.workspaceId === undefined) {
            throw new runtime.RequiredError('workspaceId','Required parameter requestParameters.workspaceId was null or undefined when calling getVwbWorkspaceResources.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("aou_oauth", []);
        }

        const response = await this.request({
            path: `/v2/admin/vwb/workspaces/{workspaceId}/resources`.replace(`{${"workspaceId"}}`, encodeURIComponent(String(requestParameters.workspaceId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetVwbWorkspaceResources200ResponseFromJSON(jsonValue));
    }

    /**
     * Returns workspace resources using service account credentials. Requires RESEARCHER_DATA_VIEW authority.
     */
    async getVwbWorkspaceResources(workspaceId: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetVwbWorkspaceResources200Response> {
        const response = await this.getVwbWorkspaceResourcesRaw({ workspaceId: workspaceId }, initOverrides);
        return await response.value();
    }

    /**
     * Returns all VWB workspaces that match the given search param. Requires RESEARCHER_DATA_VIEW authority.
     */
    async getVwbWorkspacesBySearchParamRaw(requestParameters: VwbWorkspaceAdminApiGetVwbWorkspacesBySearchParamRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<VwbWorkspaceListResponse>> {
        if (requestParameters.searchParamType === null || requestParameters.searchParamType === undefined) {
            throw new runtime.RequiredError('searchParamType','Required parameter requestParameters.searchParamType was null or undefined when calling getVwbWorkspacesBySearchParam.');
        }

        if (requestParameters.searchParam === null || requestParameters.searchParam === undefined) {
            throw new runtime.RequiredError('searchParam','Required parameter requestParameters.searchParam was null or undefined when calling getVwbWorkspacesBySearchParam.');
        }

        const queryParameters: any = {};

        if (requestParameters.searchParamType !== undefined) {
            queryParameters['searchParamType'] = requestParameters.searchParamType;
        }

        if (requestParameters.searchParam !== undefined) {
            queryParameters['searchParam'] = requestParameters.searchParam;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("aou_oauth", []);
        }

        const response = await this.request({
            path: `/v2/admin/vwb/workspaces`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => VwbWorkspaceListResponseFromJSON(jsonValue));
    }

    /**
     * Returns all VWB workspaces that match the given search param. Requires RESEARCHER_DATA_VIEW authority.
     */
    async getVwbWorkspacesBySearchParam(searchParamType: string, searchParam: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<VwbWorkspaceListResponse> {
        const response = await this.getVwbWorkspacesBySearchParamRaw({ searchParamType: searchParamType, searchParam: searchParam }, initOverrides);
        return await response.value();
    }

}
